import HighchartsReact from "highcharts-react-official";
import { useMemo } from "react";
import * as HighCharts from "highcharts";
import { useLanguageTranslator } from "../../../components";
import { Typography } from "@mui/material";

function QuantityChart({ data, chartType, type, heading }: any) {
  const { translator } = useLanguageTranslator();

  const parsedPercentageData = useMemo(() => {
    if (!data) return data;

    const indicatorsMap = {} as {
      [key: string]: {
        type: string;
        label: string;
        data: Record<string | number, any>;
      };
    };

    data.forEach((v: any) => {
      const map = indicatorsMap[v.indicator.id] || {
        type: v.indicator.ratingType,
        label: v.indicator.label,
        data: {},
        description: v?.description,
      };
      map.data[v.year] = v.value;
      indicatorsMap[v.indicator.id] = map;
    });

    return Object.values(indicatorsMap);
  }, [data]);

  const chartOptions = useMemo(() => {
    if (!parsedPercentageData) return undefined;

    return {
      chart: {
        type: chartType,
        plotBackgroundImage:
          "https://niyel-dev.testaristarc.com/assets/images/watermark.png",
        events: {
          // render() {
          //   // Clear previous watermark (in case of re-render)
          //   const chart = this as any;
          //   if (chart.watermark) {
          //     chart.watermark.destroy();
          //   }
          //   // Add an image watermark
          //   chart.watermark = chart.renderer
          //     .image("/assets/indicatorsWatermark.png", 40, 50, 500, 250)
          //     .attr({
          //       zIndex: 10,
          //       opacity: 0.1,
          //     })
          //     .add();
          // },
          //   load() {
          //     addWatermark(this);
          //   },
          //   redraw() {
          //     const yes: any = this;
          //     if (!yes.watermark) {
          //       addWatermark(this);
          //     }
          //   },
        },
      },
      tooltip: {
        enabled: true,
        shared: false,
        followPointer: true,
        useHTML: true,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        style: {
          color: "#fff",
        },
      },

      title: {
        text: null,
        align: "left",
      },
      xAxis: {
        type: "category",
      },
      exporting: {
        // beforeExport: function () {
        //   addWatermark(this);
        // },
        chartOptions: {
          chart: {
            plotBackgroundImage:
              "https://niyel-dev.testaristarc.com/assets/images/watermark.png",
            events: {
              // render() {
              //   const chart = this as any;
              //   if (chart.watermark) {
              //     chart.watermark.destroy();
              //   }
              //   chart.watermark = chart.renderer
              //     .image("/assets/indicatorsWatermark.png", 40, 50, 500, 250)
              //     .attr({
              //       zIndex: 10,
              //       opacity: 0.1,
              //     })
              //     .add();
              // },
            },
          },
        },
        enabled: true,
        allowHTML: true,
        buttons: {
          contextButton: {
            menuItems: [
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "downloadCSV",
            ],
          },
        },
      },
      navigation: {
        buttonOptions: {
          enabled: true,
        },
      },
      yAxis: {
        labels: {
          enabled: true,
        },
        title: {
          enabled: false,
        },
      },
      series: (() => {
        let tempSeries = [];
        for (let data of parsedPercentageData) {
          if (data.type !== type) continue;

          tempSeries.push({
            // color: '#F9B500',
            borderRadius: 8,
            pointWidth: 32,
            name: data.label,
            label: {
              enabled: false,
            },
            data: Object.keys(data.data)
              .sort()
              .map((k) => ({ y: Number(data.data[k]) || 0, name: k })),
          });
        }
        return tempSeries;
      })(),
    };
  }, [parsedPercentageData, chartType]);
  return (
    <>
      {chartOptions && chartOptions.series.length > 0 ? (
        <>
          <Typography
            sx={{
              fontSize: "25px",
              fontWeight: "800",
              display: "flex",
              justifyContent: "center",
            }}
            my={5}
          >
            {heading}
          </Typography>
          <HighchartsReact
            highcharts={HighCharts}
            options={chartOptions}
            containerProps={{
              style: { height: 500, pointerEvents: "auto" },
            }}
          />
        </>
      ) : (
        <Typography
          sx={{
            fontSize: "25px",
            fontWeight: "800",
            display: "flex",
            justifyContent: "center",
          }}
          my={5}
        >
          {translator("No data to plot")} {heading}.
        </Typography>
      )}
    </>
  );
}

export { QuantityChart };
